import React, { useEffect, useState } from "react";
import api, { formatIDR } from "../lib/api";
import { Wallet } from "lucide-react";

const PayrollSummaryCard = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get("/reports/payroll-summary", { params: { months: 3 } })
      .then((r) => setData(r.data))
      .catch(() => setError(true));
  }, []);

  const months = data?.months || [];

  return (
    <div className="bg-white border border-[#E4E4E7] mb-6" data-testid="payroll-summary-card">
      <div className="px-6 py-4 border-b border-[#E4E4E7] flex items-center gap-2 flex-wrap">
        <Wallet size={14} />
        <div className="label-cap">Resume Payroll Karyawan — 3 Bulan Terakhir</div>
        <div className="text-xs text-[#52525B] ml-auto">Take home pay &amp; uang bensin dari payroll tersimpan</div>
      </div>
      {error && <div className="p-6 text-sm text-[#DC2626]">Gagal memuat resume payroll.</div>}
      {!data && !error && <div className="p-6 text-sm text-[#52525B]">Memuat…</div>}
      {data && (
        <>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#E4E4E7] border-b border-[#E4E4E7]">
            {months.map((m) => (
              <div key={m.month} className="bg-white px-6 py-4">
                <div className="label-cap mb-2">{m.label}</div>
                <div className="text-xs text-[#52525B]">Take Home Pay</div>
                <div className="font-mono font-bold text-lg">{formatIDR(data.totals[m.month]?.thp || 0)}</div>
                <div className="text-xs text-[#52525B] mt-1">Uang Bensin</div>
                <div className="font-mono font-bold text-[#D97706]">{formatIDR(data.totals[m.month]?.bensin || 0)}</div>
              </div>
            ))}
          </div>
          <div className="overflow-x-auto">
            <table className="w-full min-w-[720px]">
              <thead>
                <tr className="border-b border-[#E4E4E7]">
                  <th rowSpan="2" className="text-left label-cap px-4 py-2 align-bottom">Karyawan</th>
                  {months.map((m) => (
                    <th key={m.month} colSpan="2" className="text-center label-cap px-4 py-2 border-l border-[#E4E4E7]">{m.label}</th>
                  ))}
                  <th colSpan="2" className="text-center label-cap px-4 py-2 border-l border-[#E4E4E7]">Total</th>
                </tr>
                <tr className="border-b border-[#E4E4E7]">
                  {[...months, { month: "total" }].map((m) => (
                    <React.Fragment key={m.month}>
                      <th className="text-right label-cap px-4 py-2 border-l border-[#E4E4E7]">THP</th>
                      <th className="text-right label-cap px-4 py-2">Bensin</th>
                    </React.Fragment>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.rows.length === 0 && (
                  <tr><td colSpan={months.length * 2 + 3} className="p-4 text-sm text-[#52525B]">Belum ada payroll tersimpan di periode ini.</td></tr>
                )}
                {data.rows.map((r) => (
                  <tr key={r.technician_id} className="border-b border-[#E4E4E7]">
                    <td className="px-4 py-2 text-sm font-bold whitespace-nowrap">
                      {r.name}
                      {r.role === "staff" && <span className="ml-2 text-[10px] font-bold uppercase text-[#52525B]">Staff</span>}
                    </td>
                    {months.map((m) => {
                      const v = r.months[m.month];
                      return (
                        <React.Fragment key={m.month}>
                          <td className="px-4 py-2 text-sm font-mono text-right border-l border-[#E4E4E7] whitespace-nowrap">{v ? formatIDR(v.thp) : <span className="text-[#A1A1AA]">—</span>}</td>
                          <td className="px-4 py-2 text-sm font-mono text-right text-[#D97706] whitespace-nowrap">{v ? formatIDR(v.bensin) : <span className="text-[#A1A1AA]">—</span>}</td>
                        </React.Fragment>
                      );
                    })}
                    <td className="px-4 py-2 text-sm font-mono font-bold text-right border-l border-[#E4E4E7] whitespace-nowrap">{formatIDR(r.total_thp)}</td>
                    <td className="px-4 py-2 text-sm font-mono font-bold text-right text-[#D97706] whitespace-nowrap">{formatIDR(r.total_bensin)}</td>
                  </tr>
                ))}
              </tbody>
              {data.rows.length > 0 && (
                <tfoot>
                  <tr className="bg-[#F4F4F5]">
                    <td className="px-4 py-2 text-sm font-black uppercase">Total</td>
                    {months.map((m) => (
                      <React.Fragment key={m.month}>
                        <td className="px-4 py-2 text-sm font-mono font-bold text-right border-l border-[#E4E4E7] whitespace-nowrap">{formatIDR(data.totals[m.month]?.thp || 0)}</td>
                        <td className="px-4 py-2 text-sm font-mono font-bold text-right text-[#D97706] whitespace-nowrap">{formatIDR(data.totals[m.month]?.bensin || 0)}</td>
                      </React.Fragment>
                    ))}
                    <td className="px-4 py-2 text-sm font-mono font-black text-right border-l border-[#E4E4E7] whitespace-nowrap">{formatIDR(data.grand_total.thp)}</td>
                    <td className="px-4 py-2 text-sm font-mono font-black text-right text-[#D97706] whitespace-nowrap">{formatIDR(data.grand_total.bensin)}</td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default PayrollSummaryCard;
